import { render, staticRenderFns } from "./PromotionsButtonPanel.vue?vue&type=template&id=48aceb8a"
import script from "./PromotionsButtonPanel.vue?vue&type=script&lang=js"
export * from "./PromotionsButtonPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports